import React from "react";
import { AuthProvider } from "./services/AuthContext";
import ActiveUserTimers from "./components/ActiveUserTimers";
import NotificationModal from "./components/modal/NotificationModal";
import AutoBiometricLoginListener from "./components/home/AutoBiometricLoginListener";
import AppRoutes from "./routes/AppRoutes";
import "./App.css";

const App = () => {
  return (
    <div className="App">
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
      <ActiveUserTimers />
      <NotificationModal />
      <AutoBiometricLoginListener />
    </div>
  );
};

export default App;
